module.exports = __webpack_public_path__ + "static/media/lv.9fa6c690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lv.svg
// module id = 180
// module chunks = 0